// extracted by mini-css-extract-plugin
module.exports = {"root":"Benefit_root__fXnqe","icon":"Benefit_icon__0mWPN"};